import { render } from "./peilvsheding.vue?vue&type=template&id=70789836&scoped=true"
import script from "./peilvsheding.vue?vue&type=script&lang=js"
export * from "./peilvsheding.vue?vue&type=script&lang=js"

import "./peilvsheding.vue?vue&type=style&index=0&id=70789836&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70789836"]])

export default __exports__